module.exports = __webpack_public_path__ + "img/menuIcon3.e56c3336.png";